import { ListUl } from '@styled-icons/fa-solid/ListUl';
import { ReduceCapacity } from '@styled-icons/material/ReduceCapacity';
import { SwapCalls } from '@styled-icons/material-outlined/SwapCalls';
import { Support } from '@styled-icons/boxicons-regular/Support';
import { QuestionCircle, TimesCircle } from '@styled-icons/fa-regular';
import { Cancel, CloseFullscreen, Delete, NoteAdd, PlaylistAddCheck, QueryStats } from '@styled-icons/material';
import { SettingsInputComponent } from '@styled-icons/material-outlined';
import React, { Fragment } from 'react';
import { JOB_STATUS_COLORS } from 'constants/styles';
import styled, { keyframes } from 'styled-components';
import { Ambulance, ArrowDown, ArrowLeft, ArrowRight, ArrowsUpDownLeftRight, ArrowUpLong, Asterisk, Award, Ban, Binoculars, Bolt, BoltLightning, BookOpen, Bullhorn, Bullseye, CalendarAlt, CalendarCheck, CalendarDay, CaretRight, CentSign, Certificate, ChalkboardTeacher, ChartArea, Check, CheckDouble, ChevronRight, ChevronUp, Circle, CircleNotch, Cog, Cogs, CompassDrafting, Copyright, Crown, Cubes, Database, Diamond, Dizzy, DollarSign, Download, Exclamation, Eye, EyeSlash, File, FileArrowDown, FileImport, FilePdf, FileZipper, FireFlameCurved, GasPump, Helicopter, Home, InfoCircle, Leaf, Lightbulb, List, PaperPlane, Pen, Play, PlusCircle, Rocket, ScrewdriverWrench, Search, Square, Star, StarOfLife, Table, Thumbtack, TimesCircle as SolidTimesCircle, Toolbox, Trademark, Trash, TriangleExclamation, University, UpDown, User, UserCheck, UserFriends, UserGraduate, Users, UsersGear, Vest, WeightHanging, WindowClose, Xmark, } from '@styled-icons/fa-solid';
import { find } from 'lodash';
import { Rule } from '@styled-icons/material/Rule';
import { PlaylistRemove } from '@styled-icons/material/PlaylistRemove';
import { OpenInFull } from '@styled-icons/material/OpenInFull';

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const TAG_ICONS_LIST = [
  { name: 'ScrewdriverWrench', icon: <ScrewdriverWrench size="13"/> },
  { name: 'TriangleExclamation', icon: <TriangleExclamation size="13"/> },
  { name: 'Vest', icon: <Vest size="13"/> },
  { name: 'Xmark', icon: <Xmark size="13"/> },
  { name: 'CompassDrafting', icon: <CompassDrafting size="13"/> },
  { name: 'Diamond', icon: <Diamond size="13"/> },
  { name: 'ArrowsUpDownLeftRight', icon: <ArrowsUpDownLeftRight size="13"/> },
  { name: 'ArrowUpLong', icon: <ArrowUpLong size="13"/> },
  { name: 'BoltLightning', icon: <BoltLightning size="13"/> },
  { name: 'CentSign', icon: <CentSign size="13"/> },
  
  { name: 'Star', icon: <Star size="13"/> },
  { name: 'Thumbtack', icon: <Thumbtack size="13"/> },
  { name: 'UpDown', icon: <UpDown size="13"/> },
  { name: 'UserCheck', icon: <UserCheck size="13"/> },
  { name: 'WeightHanging', icon: <WeightHanging size="13"/> },
  { name: 'Check', icon: <Check size="13"/> },
  { name: 'ChevronUp', icon: <ChevronUp size="13"/> },
  { name: 'Copyright', icon: <Copyright size="13"/> },
  { name: 'Crown', icon: <Crown size="13"/> },
  { name: 'DollarSign', icon: <DollarSign size="13"/> },
  { name: 'Exclamation', icon: <Exclamation size="13"/> },
  { name: 'File', icon: <File size="13"/> },
  { name: 'FireFlameCurved', icon: <FireFlameCurved size="13"/> },
  { name: 'Lightbulb', icon: <Lightbulb size="13"/> },
  { name: 'Play', icon: <Play size="13"/> },
  { name: 'Circle', icon: <Circle size="13"/> },
  { name: 'Square', icon: <Square size="13"/> },
  { name: 'Trademark', icon: <Trademark size="13"/> },
  { name: 'ArrowDown', icon: <ArrowDown size="13"/> },
  { name: 'ArrowLeft', icon: <ArrowLeft size="13"/> },
  { name: 'ArrowRight', icon: <ArrowRight size="13"/> },
  
  { name: 'Asterisk', icon: <Asterisk size="13"/> },
  { name: 'Award', icon: <Award size="13"/> },
  { name: 'Binoculars', icon: <Binoculars size="13"/> },
  { name: 'Bolt', icon: <Bolt size="13"/> },
  
  { name: 'Binoculars', icon: <Binoculars size="13"/> },
  { name: 'Bullhorn', icon: <Bullhorn size="13"/> },
  { name: 'Bullseye', icon: <Bullseye size="13"/> },
  
  { name: 'Certificate', icon: <Certificate size="13"/> },
];

export const getIconByTagObject = (tagObj) => {
  const iconEl = find(TAG_ICONS_LIST, { name: tagObj?.icon })?.icon;
  return iconEl ? React.cloneElement(iconEl, { color: tagObj.colour }) : <Fragment/>;
};

export const ICONS = (size, color, tooltip) => ({
  CIRCLE: <Circle size={size} color={color}/>
});

const FlyPro = () => <Helicopter size={16}/>;

const OpsInputs = () => <Ambulance size={16}/>;

const FlyProMonthlySchedule = () => <CalendarDay size={16}/>;

const Resources = () => <Cubes size={16}/>;

const Qualifications = () => <ReduceCapacity size={16}/>;

const Instructors = () => <ChalkboardTeacher size={16}/>;

const ManagedItems = () => <ListUl size={16}/>;

const StaffAircrew = () => <Users size={16}/>;

const Students = () => <UserGraduate size={14}/>;

const AvailabilityDataExort = () => <FileArrowDown size={16}/>;

const Cohorts = () => <UserFriends size={16}/>;

const DashboardDataExort = () => <FileZipper size={16}/>;

const Flights = () => <Helicopter size={16}/>;

const Groups = () => <UsersGear size={16}/>;

const Syllabi = () => <BookOpen size={16}/>;

const Settings = () => <Cogs size={16}/>;

const Squadrons = () => <Home size={16}/>;

const Supports = () => <Support size={16}/>;

const Base = () => <University size={16}/>;

const Simulation = () => <Play size={16}/>;

const Analysis = () => <ChartArea size={16}/>;

const CatOutput = () => <QueryStats size={20} color="black"/>;

const CatInput = () => <SettingsInputComponent size={18} color="black"/>;

const ScheduledStudents = () => <UserCheck size={16}/>;

const ScheduledResources = () => <Rocket size={16}/>;

const Schedule = () => <CalendarAlt size={16}/>;

const HeaderAvatar = () => <Database size={24}/>;

const MyPage = () => <User size={16}/>;

export const ContainerMenuIcons = {
  Analysis,
  AvailabilityDataExort,
  Base,
  CatOutput,
  CatInput,
  Cohorts,
  DashboardDataExort,
  Flights,
  FlyPro,
  FlyProMonthlySchedule,
  Groups,
  HeaderAvatar,
  Instructors,
  MyPage,
  ManagedItems,
  OpsInputs,
  Resources,
  Qualifications,
  Schedule,
  ScheduledResources,
  ScheduledStudents,
  Settings,
  Simulation,
  Squadrons,
  StaffAircrew,
  Students,
  Supports,
  Syllabi,
};

const ClearSearch = ({ isSmallIcons }) => <TimesCircle size={isSmallIcons ? 9 : 13}/>;

const ShowSearch = ({ isSmallIcons }) => <Search size={isSmallIcons ? 9 : 13}/>;

const HideSearch = ({ isSmallIcons }) => <ChevronRight size={isSmallIcons ? 9 : 13}/>;

export const SearchTableIcons = {
  ClearSearch,
  HideSearch,
  ShowSearch,
};

const SQN = () => <UserFriends size={16}/>;

const Remedial = () => <StarOfLife size={16}/>;

const Custom = () => <CalendarCheck size={16}/>;

const SharableCheck = () => <Check size={13} style={{ color: 'green' }}/>;

export const EventLessonModalIcons = {
  SQN,
  Remedial,
  Custom,
  SharableCheck,
};

const ImportPex = () => <FileImport size={16} style={{ margin: '0 2px' }}/>;

const AutoPlan = () => <PaperPlane size={16} style={{ margin: '0 2px' }}/>;

const ExportPdf = () => <FilePdf size={18} style={{ margin: '0 2px' }}/>;

export const ToolBarIcons = {
  ImportPex,
  AutoPlan,
  ExportPdf,
};

const ActivityRequests = () => <Rule size={22}/>;

const EventGuides = () => <Toolbox size={16}/>;

const Personnel = () => <UserFriends size={16}/>;

const RemoveAdditionalResource = () => <SolidTimesCircle size={13}/>;

const SetResourceNotRequired = ({ color }) => <Ban size={13} color={color}/>;

export const EventModalIcons = {
  EventGuides,
  Personnel,
  ActivityRequests,
  RemoveAdditionalResource,
  SetResourceNotRequired,
};

const EmptyIcon = () => <Leaf size={24}/>;

const ErrorIcon = () => <Dizzy size={24}/>;

const InProgressIcon = () => <InfoCircle size={24}/>;

export const StatusIcons = {
  EmptyIcon,
  ErrorIcon,
  InProgressIcon,
};

export const InlineDeleteButtonIcon = () => <Cancel size={16}/>;
export const InlineTrashButtonIcon = () => <Delete size={19}/>;
export const InlineEditButtonIcon = () => <Pen size={11}/>;

export const QuestionMarkIcon = () => <QuestionCircle size={13} style={{ color: '#3784f9' }}/>;

const CreateIcon = (props) => <PlusCircle size={11} style={{ color: 'white' }} {...props}/>;

const ShowGroupBarsIcon = (props) => <PlaylistAddCheck size={20} color="white"/>;

const HideGroupBarsIcon = (props) => <PlaylistRemove size={20} color="white"/>;

const ShowGroupInFullIcon = (props) => <OpenInFull size={14} color="white"/>;

const ShowGroupInCompactIcon = (props) => <CloseFullscreen size={14} color="white"/>;

const ShowEmptySwimlanesIcon = (props) => <Eye size={14} color="white"/>;

const HideEmptySwimlanesIcon = (props) => <EyeSlash size={14} color="white"/>;

const ConfigurationIcon = () => <Cog size={10} style={{ color: '#4c4c4c' }}/>;

const Fuel = () => <GasPump size={10} style={{ color: '#4c4c4c' }}/>;

const AircraftChangeIcon = () => <SwapCalls size={16}/>;

const DownloadPdf = () => <Download size={20}/>;

const ClosePdf = () => <WindowClose size={20}/>;

const StickyNoteAdd = () => <NoteAdd size={13} color="white"/>;

export const FlyProIcons = {
  CreateIcon,
  ConfigurationIcon,
  Fuel,
  AircraftChangeIcon,
  DownloadPdf,
  ClosePdf,
  StickyNoteAdd,
  ShowGroupBarsIcon,
  HideGroupBarsIcon,
  ShowGroupInFullIcon,
  ShowGroupInCompactIcon,
  ShowEmptySwimlanesIcon,
  HideEmptySwimlanesIcon
};

export const ExpandStateIcon = ({ className, isSmall }) => <CaretRight size={isSmall ? 10 : 13} className={className}/>;

const JobFailedIcon = () => <TimesCircle size={11} color="#DE350B"/>;

const JobInProgress = styled(CircleNotch)`
  animation: 2s linear ${spin} infinite;
  height: 10px;
  width: 10px;
  color: #0052CC;
`;

const JobSuccess = () => <Circle size={11} color={JOB_STATUS_COLORS.SUCCEEDED}/>;
const JobAccepted = () => <CheckDouble size={11} color="#36B37E"/>;
const JobRejected = () => <Ban size={11} color="#DE350B"/>;
const JobCancelIcon = () => <Xmark size={12} color="#DE350B"/>;
const JobDeleteIcon = () => <Trash size={12} color="#6B778C"/>;

export const JobIcons = {
  JobFailedIcon,
  JobInProgress,
  JobSuccess,
  JobAccepted,
  JobRejected,
  JobCancelIcon,
  JobDeleteIcon,
};

export const CloseFloatingWindowIcon = styled(WindowClose)`
  cursor: pointer;
  height: 16px;
  width: 16px;
`;

const ShowContentsInListIcon = () => <List size={14}/>;

const ShowContentsInTableIcon = () => <Table size={14}/>;

export const ShowContentsIcons = {
  ShowContentsInListIcon,
  ShowContentsInTableIcon,
};
